import { clientFor, type PageQuery, type PageResult, type Status } from '@yc/api-client'

const api = clientFor('/ops/api')

/** 计费模式：决定计费数量取订单的里程 / 重量 / 两者的积 / 固定 1 单 */
export type RateMode = 'per_km' | 'per_kg' | 'per_kgkm' | 'per_order'

/** 计费规则。字段与 services/ops/internal/rate/rate.go 的 RateCard 一一对应。 */
export interface RateCard {
  id: number
  tenant_id: number
  code: string
  name: string
  mode: RateMode
  /** 单价，DECIMAL(12,4) */
  unit_price: number
  /** 起步价，金额下限 */
  min_price: number
  /** 生效日期 YYYY-MM-DD，null 表示不限 */
  effective_from: string | null
  status: Status
  created_at: string
  updated_at: string
}

export interface RateInput {
  code: string
  name: string
  mode: RateMode
  unit_price: number
  min_price: number
  effective_from?: string | null
  status: Status
}

export interface RateQuery extends PageQuery {
  keyword?: string
  status?: string
}

/** 与后端 services/ops/internal/rate/rate.go 的 ModeNames 同源两份，改一边必须改另一边 */
export const MODE_LABELS: Record<RateMode, string> = {
  per_km: '按公里',
  per_kg: '按公斤',
  per_kgkm: '按公斤公里',
  per_order: '按单',
}

/** 与后端 services/ops/internal/rate/rate.go 的 StatusNames 同源两份 */
export const STATUS_LABELS: Record<Status, string> = { active: '启用', disabled: '停用' }

export const listRateCards = (q: RateQuery): Promise<PageResult<RateCard>> =>
  api.get<PageResult<RateCard>>('/rate-cards', { ...q })

export const createRateCard = (input: RateInput): Promise<RateCard> =>
  api.post<RateCard>('/rate-cards', input)

export const updateRateCard = (id: number, input: RateInput): Promise<RateCard> =>
  api.put<RateCard>(`/rate-cards/${id}`, input)

export const deleteRateCard = (id: number): Promise<void> => api.del<void>(`/rate-cards/${id}`)

/** 计费弹窗里的规则下拉：只给启用的规则（后端要求计费规则处于启用态） */
export const listActiveRateCards = (): Promise<RateCard[]> =>
  listRateCards({ page: 1, size: 200, status: 'active' }).then((page) => page.list)
